import { render, staticRenderFns } from "./marchIntoDetail.vue?vue&type=template&id=53b492e4&"
import script from "./marchIntoDetail.vue?vue&type=script&lang=js&"
export * from "./marchIntoDetail.vue?vue&type=script&lang=js&"
import style0 from "./marchIntoDetail.vue?vue&type=style&index=0&id=53b492e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports